/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ColabService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List trainer videos for Colab export
     * Platform-level super admin endpoint — returns all R2 videos across all trainers.
     * @returns any List of videos with stream URLs
     * @throws ApiError
     */
    public getColabVideos(): CancelablePromise<{
        videos: Array<{
            id: string;
            title: string | null;
            r2Key: string | null;
            processedR2Key: string | null;
            streamUrl: string;
            uploadComplete: boolean;
            createdAt: string;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/colab/videos',
            errors: {
                401: `Invalid or missing API key`,
            },
        });
    }

    /**
     * Upload processed video result
     * Store a Sapiens2-processed video back to R2 and record the key.
     * @returns any Processed video stored
     * @throws ApiError
     */
    public putColabVideosProcessed({
        id,
    }: {
        id: string,
    }): CancelablePromise<{
        processedR2Key: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/colab/videos/{id}/processed',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid or missing API key`,
                404: `Video not found`,
            },
        });
    }

}
